import { ReactNode } from "react"

import {
  ColorMap as _ColorMap,
  ColorVariant as _ColorVariant,
} from "utils/color"
import { css, cx } from "@emotion/css"

export type ColorVariant = _ColorVariant | "successDark" | "waiting" | "manual"

export const ColorMap: Record<string, ColorVariant> = {
  ..._ColorMap,
  SUCCESS: "successDark",
  FAILURE: "error",
  WAITING: "waiting",
  MANUAL: "manual",
}

const styles = {
  root: css`
    display: inline-flex;
    align-items: center;
    border-radius: 0.25rem;
    max-width: 10rem;
    position: relative;

    text-transform: capitalize;
    font-size: 0.8125rem;
    color: var(--black);
    line-height: 1;
    text-align: center;
    vertical-align: center;

    .text {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      height: var(--spacing-m);
      margin-top: var(--spacing-xxs);
    }

    --dot-color: var(--grey, #a8a8a8);

    ::before {
      content: "●";
      color: var(--dot-color);
      font-size: 1.125rem;
      margin: 0 var(--spacing-xxs) 0 0;
    }
  `,

  margins: {
    default: css`
      padding: 0 var(--spacing-xxs) 0 0;
    `,
    dense: css`
      padding: 0;
    `,
  },

  colors: {
    default: css`
      --dot-color: var(--grey);
    `,
    info: css`
      --dot-color: var(--black);
    `,
    approved: css`
      --dot-color: var(--primary-main);
    `,
    live: css`
      --dot-color: var(--secondary-light-blue);
    `,
    success: css`
      --dot-color: var(--primary-main);
    `,
    warning: css`
      --dot-color: var(--tertiary-light-yellow);
    `,
    error: css`
      --dot-color: var(--red);
    `,
    new: css`
      --dot-color: var(--secondary-dark-blue-2);
    `,
    partial: css`
      --dot-color: var(--purple);
    `,
    waiting: css`
      --dot-color: var(--disabled-grey);
    `,
    manual: css`
      --dot-color: var(--tertiary-light-blue);
    `,
    successDark: css`
      --dot-color: var(--primary-dark);
    `,
    warningAlt: css`
      --dot-color: var(--secondary-light-orange);
    `,
    darkPurple: css`
      --dot-color: var(--tertiary-dark-purple);
    `,
    lightBlue: css`
      background-color: var(--grey);
    `,
  },
}

export type StatusProps = {
  children: ReactNode
  className?: string
  color?: ColorVariant
  margin?: "default" | "dense"
}

export function Status(props: StatusProps) {
  const {
    children,
    className,
    //
    color = "default",
    margin = "default",
  } = props

  const cn = cx(
    styles.root,
    //
    styles.margins[margin],
    styles.colors[color],
    className,
  )

  return (
    <div className={cn}>
      <span className="text">{children}</span>
    </div>
  )
}
